import { Component, inject, ChangeDetectionStrategy } from '@angular/core';

import { AppService } from 'src/app/services/app.service';

import { LoadingScreenDefaultComponent } from './loading-screen-default/loading-screen-default.component';

@Component({
    selector: 'app-loading-screen',
    templateUrl: './loading-screen.component.html',
    styleUrls: ['./loading-screen.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [LoadingScreenDefaultComponent],
})
export class LoadingScreenComponent {
    appService = inject(AppService);
}
